import { writable, derived } from 'svelte/store'

export const questionsWrite = writable([]);

export const settings = writable([]);

export const statistics = derived([questionsWrite, settings], ([$questionsWrite, $settings]) => {
    let total = $questionsWrite.length * $settings.requiredAnswersPerQuestion;
    let score = 0;
    let scorePers = 0;
    let errors = 0;
    $questionsWrite.forEach(function (element) {
        errors = errors + element.errors;
        score = score + element.runCount;
    });
    scorePers = Math.ceil((100 / total) * score);
    return { total, score, scorePers, errors }
});

// export const questionsRead = derived([questionsWrite, settings], ([$questionsWrite, $settings]) => {
//     if ($settings.rotate) {
//         return $questionsWrite.map(o => {
//             return { id: o.id, key: o.val, val: o.key, runCount: o.runCount, errors: o.errors, completed: o.completed, choices: o.choices };
//         });
//     };
//     return $questionsWrite;
// });

// export const nextQuestion = derived([questionsWrite, settings], ([$questionsWrite, $settings]) => {
//     const remainingQuestions = $questionsWrite.filter(i => i.completed == false);
//     if (remainingQuestions.length == 0) return null;
//     const questionToReturn =
//         remainingQuestions[Math.floor(Math.random() * remainingQuestions.length)];
//     questionToReturn.choices = BuildAnswers(
//         questionToReturn.key,
//         questionToReturn.val,
//         $questionsWrite,
//         $settings.answerChoicesUpTo
//     );
//     return questionToReturn;
// });

